import { useCallback } from 'react';

const useGridServerSideDataSource = ({ fetchData, initialRows = false }) => {
  const createDatasource = useCallback(() => {
    let initialRowsUsed = false;
    return {
      getRows: async params => {
        if (!initialRowsUsed && initialRows) {
          params.successCallback(initialRows);
          initialRowsUsed = true;
          return;
        }

        try {
          const result = await fetchData({
            limit: (params.request.endRow - params.request.startRow),
            offset: params.request.startRow,
            sortModel: params.request.sortModel,
            filterModel: params.request.filterModel,
          });

          params.successCallback(result);
        } catch (error) {
          params.failCallback();
        }
      },
    };
  }, [fetchData, initialRows]);

  const onGridReady = useCallback(({ api }) => {
    api.setServerSideDatasource(createDatasource());
  }, [createDatasource]);

  return {
    onGridReady,
  };
};

export default useGridServerSideDataSource;
